/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiStaticFile } from '@Model';
import type { HttpActions, ResponseResolver, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of FilesController.
 */
export class FilesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /files
     */
    public uploadFile(file: File): Promise<Result<ApiStaticFile>> {
        return this.http.post<Result<ApiStaticFile>, File>('/files', file);
    }

    /**
     * Calls GET /files/{id}
     */
    public downloadFile<TResponse = unknown>(id: string, responseResolver?: ResponseResolver<TResponse>): Promise<TResponse> {
        return this.http.get<TResponse>(`/files/${id}`, undefined, responseResolver);
    }
}
